export default __webpack_public_path__ + "static/media/1011.1a29d425.png";